import { NegotiateWebsocketUrlResponse, RawSpeechTokenResponse } from '@services/types';

function parseHmsToMilliseconds(hms: string): number {
    const [hours, minutes, seconds] = hms.split(':').map(Number);
    return ((hours * 60 + minutes) * 60 + seconds) * 1000;
}

export const calculateRefetchInterval = (
    data: NegotiateWebsocketUrlResponse | RawSpeechTokenResponse | undefined
): number | false => {
    if (!data) return false;
    const { expirationTime } = data;
    return parseHmsToMilliseconds(expirationTime);
};
